// <s-mega-menu> closes its <details> panel on outside click, Escape, and focus leaving the menu.
class SMegaMenu extends HTMLElement {
  #ac;

  connectedCallback() {
    const details = this.querySelector('details');
    if (!details) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    document.addEventListener(
      'click',
      (event) => {
        if (details.open && !this.contains(event.target)) details.open = false;
      },
      { signal }
    );

    this.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          details.querySelector('summary')?.focus();
        }
      },
      { signal }
    );

    this.addEventListener(
      'focusout',
      (event) => {
        if (details.open && event.relatedTarget && !this.contains(event.relatedTarget)) details.open = false;
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-mega-menu')) customElements.define('s-mega-menu', SMegaMenu);
